<div class="padding-top footerblock bg_black">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-12 footer_column">
                <h3 class="heading">Horaire d'ouverture</h3>
                <hr class="half_space">
                <div *ngIf="pdv?.openingtext" [innerHtml]="pdv?.openingtext" class="opening"></div>
            </div>
            <div class="col-md-4 col-sm-12 footer_column contact">
                <h3 class="heading">Contact</h3>
                <hr class="half_space">
                <p class="address">
                    <i class="flaticon-pin"></i>
                    <a #maplink href="#" target="_blank"> {{pdv?.address}}</a>
                </p>
                <p class="phone">
                    <i class="flaticon-phone-on-circle"></i>
                    <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
                </p>
                <p class="email" *ngIf="pdv?.emailContact">
                    <i class="flaticon-arroba"></i>
                    <a href="mailto:{{pdv?.emailContact}}">
                        {{pdv?.emailContact}}
                    </a>
                </p>
                <p class="email" *ngIf="pdv?.facebook">
                    <i class="flaticon-facebook"></i>
                    <a href="{{pdv?.facebook}}" target="_blank" class="facebook">
                        Contactez-nous sur facebook
                    </a>
                </p>
            </div>
            <div class="col-md-4 col-sm-12 footer_column">
                <h3 class="heading">Zones de livraison</h3>
                <hr class="half_space">
                <div class="cont-zone">
                    <div class="row content" [hidden]="i>6 && !displayAll"
                        *ngFor="let zone of authorizedCities;let i=index">
                        <div class="col-md-8 left">
                            {{zone.name}}
                        </div>
                        <div class="col-md-4 right">
                            <span class="cir">{{zone.amountMiniDelivery  | helpycurrency}}</span>
                        </div>
                    </div>
                    <button class="btn more" *ngIf="authorizedCities.length>9" (click)="displayAll=!displayAll">
                        Voir
                        <ng-container *ngIf="!displayAll">
                            plus ...
                        </ng-container>
                        <ng-container *ngIf="displayAll">
                            moins ...
                        </ng-container>
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 copyright">
                <div class="row">
                    <div class="col-md-6">
                        <div class="clearfix">
                            <p>
                                Copyright © {{currentYear}}
                                <a class="helpyfood" href="http://www.helpyfood.com" target="_blank">Helpyfood</a>. Tous droits réservés
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <ul class="cgv-links pull-right">
                            <li>
                                <a [routerLink]="'/cgv'" target="_blank" rel="noopener noreferrer">GCV</a>
                            </li>
                            <li>
                                <a [routerLink]="'/mention-légale'" target="_blank" rel="noopener noreferrer">Mention légale</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footerLinks" *ngIf="authorizedCities.length > 0 && families.length > 0" style="display:none;">
    <ng-container *ngFor="let family of families">
        <ng-container *ngFor="let zone of authorizedCities">
            <a routerLink="/commander/livraison-{{ family.label | lowercase }}-{{zone.name|lowercase}}">
                commander {{family.label|titlecase}} à {{zone.name|titlecase}}
            </a>
            <a routerLink="/restaurant-{{ family.label | lowercase }}-{{zone.name|lowercase}}">
                {{family.label|titlecase}} {{zone.name|titlecase}}
            </a>
            <a routerLink="/restaurant-livraison-{{ family.label | lowercase }}-{{zone.name|lowercase}}">
                livraison {{family.label|titlecase}} {{zone.name|titlecase}}</a>
        </ng-container>
    </ng-container>
</div>